<template>
    <v-card class="h-100 elevation-0 blockColumn_card">
        <v-card-title class="m-0 p-0" style="height: 70px">
            <v-container  class="px-4" >
                <v-row no-gutters v-if="selectedChat!=null">
                    <v-col cols="auto">
                        <v-avatar class="m-auto"
                                  size="40"
                                  color="teal"
                        >
                            <img
                                    v-if="selectedChat!=null&&selectedChat.clientLogo!=null"
                                    :src="$root.docsUrl+selectedChat.clientLogo"
                            >
                            <img v-else src="../../assets/noavatar.png" height="40" width="40"/>
                        </v-avatar>
                    </v-col>
                    <v-col class="ml-2">
                        <div class="client-name">{{selectedChat!=null?selectedChat.clientName:''}}</div>
                        <div class="client-st2 client-status">Активный</div>
                        <div v-if="false" :class="{'client-st1':selectedChat.clientStatusCode=='CS01','client-st2':selectedChat.clientStatusCode=='CS02','client-st4':selectedChat.clientStatusCode=='CS04'}">{{selectedChat.clientStatusName}}</div>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="auto">
                        <div  v-if="selectedChat!=null&&selectedChat.requestAnswerStatusCode=='AS01'"
                              style="font-style: italic;font-weight: normal;font-size: 14px;line-height: 20px; color: #6E7C8D; padding: 10px; margin: 0 auto">
                            Дождитесь ответа клиента
                        </div>
                        <v-btn
                                v-if="selectedChat!=null&&selectedChat.requestAnswerStatusCode=='AS05'"
                                dark color="var(--color-blue)"
                                @click="acceptOrder"
                        >
                            Принять заказ
                        </v-btn>

                    </v-col>
                </v-row>
            </v-container>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="p-0 m-0" style="height: calc(100% - 145px)">
            <v-row
                    id="chatContainer"
                    no-gutters
                    align-v="end"
                    class="message-container"
            >
                <b-col >

                    <div  v-if="selectedChat!=null" class="leftContainer">
                        <div class="message">
                            <div style="display: inline-block;">{{ selectedChat.requestText }}</div>
                        </div>
                    </div>
                    <template v-for="message in chatMessages">
                        <chatMessage :message="message" :key="message.chatMessageId"></chatMessage>
                    </template>
                </b-col>
            </v-row>
        </v-card-text>
        <v-card-actions>

            <v-footer absolute style="min-height: 50px">
                <b-input-group v-if="selectedChat!=null">
                    <b-form-input
                            v-model="sendMessageModel.message"
                            :disabled="selectedChat==null"
                            placeholder="Ваше сообщение"
                            @input="resetCounter"
                            @keyup.native.enter="sendMessage"
                    />
                    <b-input-group-append>
                        <b-button
                                :disabled="selectedChat==null"
                                size="sm"
                                variant="primary"
                                @click="sendMessage"
                        >
                            <v-icon color="white">
                                near_me
                            </v-icon>
                        </b-button>
                        <b-button
                                v-if="false"
                                size="sm"
                                variant="dark"
                        >
                            <v-icon color="white">
                                attach_file
                            </v-icon>
                        </b-button>
                    </b-input-group-append>
                </b-input-group>
            </v-footer>
        </v-card-actions>
    </v-card>
</template>

<script>
    import { mapGetters } from 'vuex';
    import chatMessage from './ChatsMessage.vue'
    import {DateTime} from 'luxon'
    export default {
        name: "OrderContent",
        components:{chatMessage},
        props:{
            selectedChat:Object
        },
        data(){
            return {
                sendMessageModel: {
                    chatId: null,
                    message: null
                }
            }
        },
        computed:{
            ...mapGetters({
                getMessages: "Chats/getMessages",
            }),

            chatMessages() {
                if(this.selectedChat!=null)
                    return this.getMessages;
                else return []
            },
        },
        methods:{
            //форматирование даты+время отправки сообщения
            formatDate(date) {
                let now = new Date()
                var today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
                let dt = new Date(date)
                if (dt < today) {
                    return DateTime.fromISO(date, {zone: "local"}).toFormat("dd LLL T", {locale: "ru"})
                }
                else
                    return DateTime.fromISO(date, {zone: "local"}).toFormat("T")
            },
            //отправить сообщение в чат
            sendMessage() {
                if (this.sendMessageModel.message != null && this.sendMessageModel.message != '') {
                    this.$store.dispatch("Chats/sendMessage", this.sendMessageModel).then((data) => {
                        if (data != null) {
                            var mesModel = {
                                chatMessageId: data.id,
                                isClient: false,
                                chatId: this.sendMessageModel.chatId,
                                message: this.sendMessageModel.message,
                                messageDate: DateTime.local().toISO(),
                                requestAnswerId: null
                            }
                            var params = {
                                message: mesModel,
                                CountNotReadChatMessage: 0
                            }
                            this.$store.dispatch("Chats/putMessage", params).then(() => {

                                var curChat = this.selectedChat;
                                this.selectedChat = null;
                                this.selectedChat = curChat;
                                this.sendMessageModel.message = null;
                                var objDiv = document.getElementById("chatContainer");
                                objDiv.scrollTop = objDiv.scrollHeight;
                            }).catch(err => {
                                this.$bvToast.toast(err.message, {
                                    title: `Ошибка отправки сообщения!`,
                                    variant: "danger",
                                    toaster: 'b-toaster-bottom-right',
                                    autoHideDelay: 3000,
                                    solid: true
                                })

                            })
                        }
                    })
                }
                else {
                    this.$bvToast.toast("Необходимо ввести сообщение!", {
                        variant: "warning",
                        toaster: 'b-toaster-bottom-left',
                        autoHideDelay: 3000,
                        solid: true
                    })
                }

            },

            resetCounter() {
                if (this.selectedChat != null) {
                    //если есть непрочитанные сообщения обнуляем счетчик
                    if (this.selectedChat.countNotReadChatMessage > 0) {
                        let id = this.selectedChat.chatId;
                        this.$store.dispatch("Chats/resetMessageCounter", id).then(() => {
                            console.log(`Обнуление счетчика сообщений ${id}`)
                        })
                    }
                }
            },

            //принять заказ
            acceptOrder(){
                if(this.selectedChat!=null){
                    this.$store.dispatch("Chats/acceptChat", this.selectedChat.chatId).then(()=>{
                        this.$emit("accept", this.selectedChat.chatId)
                    })
                }
            },
        },
        watch:{
            selectedChat(value){
                if(value!=null){
                    this.sendMessageModel.chatId = this.selectedChat.chatId;
                    this.$store.dispatch("Chats/getChatMessages", this.selectedChat.chatId).then(() => {
                        this.resetCounter()
                        //прокручиваем вниз
                        var objDiv = document.getElementById("chatContainer");
                        objDiv.scrollTop = objDiv.scrollHeight;
                    })

                }
            }
        }
    }
</script>

<style scoped>
    .client-name{
        font-weight: bold;
        font-size: 16px;
        line-height: 20px;
        color: #1A2A3A;
    }

    .client-status{
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
    }

    .message-container{
        overflow-x: hidden;
        top:70px;
        right: 0px;
        left: 0px;
        bottom: 50px;
        position: absolute;
        margin: 0px; padding: 0px;
        background-color: black;
    }
</style>